export const DEFAULT_CITY = {
  id: "chisinau",
  name: {
    ro: "Chișinău",
    ru: "Кишинёв",
  },
  lat: 47.0105,
  lon: 28.8638,
};

export const MOLDOVA_CITIES = [
  {
    id: "chisinau",
    name: { ro: "Chișinău", ru: "Кишинёв" },
    lat: 47.0105,
    lon: 28.8638,
  },
  {
    id: "balti",
    name: { ro: "Bălți", ru: "Бельцы" },
    lat: 47.7631,
    lon: 27.9289,
  },
  {
    id: "cahul",
    name: { ro: "Cahul", ru: "Кагул" },
    lat: 45.9042,
    lon: 28.1993,
  },
  {
    id: "orhei",
    name: { ro: "Orhei", ru: "Оргеев" },
    lat: 47.3849,
    lon: 28.8245,
  },
  {
    id: "comrat",
    name: { ro: "Comrat", ru: "Комрат" },
    lat: 46.2946,
    lon: 28.6565,
  },
  {
    id: "soroca",
    name: { ro: "Soroca", ru: "Сороки" },
    lat: 48.1566,
    lon: 28.2849,
  },
  {
    id: "ungheni",
    name: { ro: "Ungheni", ru: "Унгены" },
    lat: 47.2108,
    lon: 27.8005,
  },
];